module.exports = __webpack_public_path__ + "media/fonts/formular-regular-webfont-a83b46b1d450506875d7755210c928d4.woff";